import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withModifiers as _withModifiers, withKeys as _withKeys, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "plan-content"
}
const _hoisted_2 = {
  key: 0,
  class: "w-full"
}
const _hoisted_3 = { class: "headers" }
const _hoisted_4 = {
  key: 0,
  class: "iatse-icon-info-circle-solid icon_rotate_0 icon_danger icon-tooltip icon-tooltip-secondary fs-lg"
}
const _hoisted_5 = { class: "tooltip-text left-20" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h5", null, " This is your Primary address for all correspondences from the Fund Office ", -1)
const _hoisted_7 = {
  key: 1,
  class: "w-full justify-content-start"
}
const _hoisted_8 = { class: "action-buttons flex-md-row flex-column sm-pdl-0 sm-pdr-0" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn btn-primary"
}, " Submit ", -1)
const _hoisted_10 = {
  key: 1,
  class: "d-flex flex-column gap-4"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h3", null, "To Continue Please...", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MessageCard = _resolveComponent("MessageCard")!
  const _component_Alerts = _resolveComponent("Alerts")!
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_SelectComponent = _resolveComponent("SelectComponent")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_DateInput = _resolveComponent("DateInput")!
  const _component_Textarea = _resolveComponent("Textarea")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MessageCard, {
      message: _ctx.message,
      type: "primary",
      iconClass: "iatse-icon-alarm",
      classes: "info_card_full"
    }, null, 8, ["message"]),
    _createVNode(_component_Alerts, { errors: _ctx.generalErrors }, null, 8, ["errors"]),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.person && _ctx.person.DateofBirth)
            ? (_openBlock(), _createElementBlock("form", {
                key: 0,
                id: "check-replacement-form",
                class: "form",
                method: "POST",
                onSubmit: _cache[19] || (_cache[19] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitData && _ctx.submitData(...args)), ["prevent"])),
                onKeypress: _cache[20] || (_cache[20] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.submitData && _ctx.submitData(...args)), ["prevent"]), ["enter"]))
              }, [
                _createVNode(_component_SelectComponent, {
                  label: "Check Type",
                  selectedOption: _ctx.requestType,
                  "onUpdate:selectedOption": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.requestType) = $event)),
                  options: _ctx.checkTypes,
                  singleArrow: true,
                  readonly: true
                }, null, 8, ["selectedOption", "options"]),
                _createVNode(_component_SelectComponent, {
                  label: "Type",
                  selectedOption: _ctx.checkType,
                  "onUpdate:selectedOption": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.checkType) = $event)),
                  options: _ctx.paymentMethods,
                  singleArrow: true,
                  "is-required": true,
                  error: _ctx.errors?.CheckType
                }, null, 8, ["selectedOption", "options", "error"]),
                _createVNode(_component_TextInput, {
                  type: "text",
                  label: "Participant ID",
                  placeholder: "Enter Participant ID",
                  max: 25,
                  modelValue: _ctx.person.PersonID,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.person.PersonID) = $event)),
                  readonly: true
                }, null, 8, ["modelValue"]),
                _createVNode(_component_TextInput, {
                  type: "text",
                  label: "First Name",
                  placeholder: "Enter First Name",
                  max: 12,
                  modelValue: _ctx.person.FirstName,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.person.FirstName) = $event)),
                  readonly: true
                }, null, 8, ["modelValue"]),
                _createVNode(_component_TextInput, {
                  type: "text",
                  label: "Last Name",
                  placeholder: "Enter Last Name",
                  max: 25,
                  modelValue: _ctx.person.LastName,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.person.LastName) = $event)),
                  readonly: true
                }, null, 8, ["modelValue"]),
                _createVNode(_component_DateInput, {
                  label: "DOB",
                  modelValue: _ctx.person.DateofBirth,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.person.DateofBirth) = $event)),
                  readonly: true
                }, null, 8, ["modelValue"]),
                (_ctx.checkType?.key === 'check')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _createVNode(_component_SelectComponent, {
                        label: "Check List",
                        selectedOption: _ctx.selectedCheck,
                        "onUpdate:selectedOption": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedCheck) = $event)),
                        options: _ctx.checkOptions,
                        singleArrow: true,
                        onChange: _ctx.handleSelectedCheck
                      }, null, 8, ["selectedOption", "options", "onChange"]),
                      _createVNode(_component_DateInput, {
                        label: "Check Date",
                        modelValue: _ctx.checkDate,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.checkDate) = $event))
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_TextInput, {
                        type: "text",
                        name: "number",
                        label: "Check #",
                        modelValue: _ctx.checkNumber,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.checkNumber) = $event))
                      }, null, 8, ["modelValue"])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("h4", {
                    class: _normalizeClass({'position-relative': _ctx.addressErrors})
                  }, [
                    _createTextVNode("Address for Check Destination currently on File "),
                    (_ctx.addressErrors)
                      ? (_openBlock(), _createElementBlock("i", _hoisted_4, [
                          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.addressErrors), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ], 2),
                  _hoisted_6
                ]),
                (_ctx.address)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createVNode(_component_TextInput, {
                        type: "text",
                        label: "Address 1",
                        placeholder: "Enter Address 1",
                        max: 30,
                        name: "mixed",
                        modelValue: _ctx.address.Street1,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.address.Street1) = $event)),
                        required: true,
                        "is-required": true,
                        error: _ctx.errors?.Street1
                      }, null, 8, ["modelValue", "error"]),
                      _createVNode(_component_TextInput, {
                        type: "text",
                        label: "Address 2",
                        placeholder: "Enter Address 2",
                        max: 30,
                        name: "mixed",
                        modelValue: _ctx.address.Street2,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.address.Street2) = $event))
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_TextInput, {
                        type: "text",
                        label: "Address 3",
                        placeholder: "Enter Address 3",
                        max: 30,
                        name: "mixed",
                        modelValue: _ctx.address.Street3,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.address.Street3) = $event))
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_TextInput, {
                        type: "text",
                        label: "Address 4",
                        placeholder: "Enter Address 4",
                        max: 30,
                        name: "mixed",
                        modelValue: _ctx.address.Street4,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.address.Street4) = $event))
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_TextInput, {
                        type: "text",
                        name: "mixed",
                        placeholder: "Enter City",
                        label: ['US', 'CA', 'MX'].includes(_ctx.address.Country?.key) ? 'City' : 'City/State',
                        max: 25,
                        modelValue: _ctx.address.City,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.address.City) = $event)),
                        required: true,
                        error: _ctx.errors?.City,
                        isRequired: true
                      }, null, 8, ["label", "modelValue", "error"]),
                      _createVNode(_component_SelectComponent, {
                        label: "State",
                        selectedOption: _ctx.address.State,
                        "onUpdate:selectedOption": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.address.State) = $event)),
                        options: _ctx.filteredStates,
                        "single-arrow": true,
                        error: _ctx.errors?.State,
                        isRequired: ['US', 'CA', 'MX'].includes(_ctx.address.Country?.key),
                        readonly: !['US', 'CA', 'MX'].includes(_ctx.address.Country?.key)
                      }, null, 8, ["selectedOption", "options", "error", "isRequired", "readonly"]),
                      _createVNode(_component_SelectComponent, {
                        label: "Country",
                        selectedOption: _ctx.address.Country,
                        "onUpdate:selectedOption": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.address.Country) = $event)),
                        options: _ctx.profileStore.countries,
                        "single-arrow": true
                      }, null, 8, ["selectedOption", "options"]),
                      _createVNode(_component_TextInput, {
                        type: "text",
                        label: "ZIP Code",
                        name: "number",
                        placeholder: "Enter Postal Code",
                        max: 9,
                        modelValue: _ctx.address.Zip,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.address.Zip) = $event)),
                        required: true,
                        "is-required": true,
                        error: _ctx.errors?.Street1
                      }, null, 8, ["modelValue", "error"])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_Textarea, {
                  label: "Notes",
                  modelValue: _ctx.comments,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.comments) = $event)),
                  max: 500,
                  message: "Notes field accepts up to 500 characters"
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("a", {
                    href: "",
                    onClick: _cache[18] || (_cache[18] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.resetModal && _ctx.resetModal(...args)), ["prevent"])),
                    class: "btn btn-secondary"
                  }, " Discard "),
                  _hoisted_9
                ])
              ], 32))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("h6", null, [
                  _createTextVNode("Please "),
                  _createElementVNode("a", {
                    href: "#",
                    onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.openModal('profile', 'My Profile', 'plan-profile plan-tables')))
                  }, " update your personal information"),
                  _createTextVNode(" to include your correct date of birth.")
                ])
              ]))
        ]))
  ], 64))
}